// @flow
import * as React from "react";

import { Outlet } from "react-router-dom";

import Header from "../Header";
import Footer from "../Footer";

function AppLayout(): React.Node {
  return (
    <>
      <Header />
      <div className="container-fluid py-2">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default AppLayout;
